import React from 'react';
import TitleBar from 'frameless-titlebar';
import { channels } from 'shared/constants';
import { useAppSelector } from 'app/store';
import { getAppInfo } from 'app/store/Electron/selectors';
import { TitleBarProps } from 'frameless-titlebar/dist/title-bar/typings';
import { HEADER_HEIGHT } from 'app/components/HeaderBar/constants';

interface FramelessTitleBarProps {
  theme?: TitleBarProps['theme'];
  children?: React.ReactNode;
}

const { api } = window;

export const FramelessTitleBar: React.FC<FramelessTitleBarProps> = ({
  children,
  theme: themeProp = {},
}) => {
  const platform = useAppSelector(getAppInfo)?.platform;
  const handleClose = () => api.send(channels.WINDOW.CLOSE);
  const handleMinimize = () => api.send(channels.WINDOW.MINIMIZE);
  const handleMaximize = () => api.send(channels.WINDOW.MAXIMIZE);

  return (
    <TitleBar
      platform={platform}
      onClose={handleClose}
      onMinimize={handleMinimize}
      onMaximize={handleMaximize}
      onDoubleClick={handleMaximize}
      theme={{
        ...themeProp,
        bar: {
          palette: 'light',
          background: 'transparent',
          borderBottom: 'none',
          height: HEADER_HEIGHT,
          inActiveOpacity: 1,
          ...themeProp?.bar,
        },
      }}
    >
      {children}
    </TitleBar>
  );
};
